import Vue from 'vue';
import Constants from '@/constants/constants';
import { Mixin } from 'vue-mixin-decorator';
import { SpotlightTextColor } from '@/shared/components/SpotlightText.component.vue';

@Mixin
class NotificationMessage extends Vue {
  protected ownSpotlightTextColor = SpotlightTextColor;

  protected notification = {
    message: '',
    style: '',
    appear: false,
    show: false,
    timeToAppear: Constants.notificationMessageTimeToAppear,
    color: this.ownSpotlightTextColor.Primary,
  };

  public hideNotificationMessage(time: number) {
    setTimeout(() => {
      this.notification.appear = false;
      setTimeout(() => {
        this.notification.show = false;
      }, 300);
    }, time);
  }

  public showNotification(
    message: string,
    color: SpotlightTextColor = this.ownSpotlightTextColor.Primary,
    timeClose: number = 300,
    timeOpen: number = 300,
  ) {
    console.log(message, color);
    this.notification.message = message;
    this.notification.color = color;

    setTimeout(() => {
      this.notification.appear = true;
      this.notification.show = true;
      setTimeout(() => {
        this.hideNotificationMessage(timeClose);
      }, this.notification.timeToAppear);
    }, timeOpen);
  }
}

export default NotificationMessage;
